/* eslint-disable max-len */
import { Box, Button, Theme, Typography, styled, useMediaQuery } from "@mui/material";

import React from "react";
import { openStore } from "../../utils/device";

const HeaderBox = styled(Box)({
  height: "49px",
  backgroundColor: "#222222",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "7px 18px 7px 18px",
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: 1000,
  width: "100%",
  boxShadow: "0px 3px 6px #00000029",
});

const OpenAppButton = styled(Button)({
  padding: "0.62rem 1.25rem 0.5rem",
  borderRadius: "6.25rem",
  fontSize: "0.625rem",
  fontWeight: "bold",
  backgroundColor: "#FEC20B",
  height: "unset",
});


type props ={
  isTop?: boolean;
  isLanding?: boolean;
  isMobile?: boolean;
}
const AppHeaderMobile = (Props : props) => {
  const { isLanding=false, isMobile=false } = Props;
  const isLargeScreen = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));

  if (isLargeScreen) {
    return null;
  }

  return (
    <HeaderBox sx={{ position: isLanding? "relative": "", width: isLanding ? "unset":
      isMobile ? "100%" : "calc(100% - 63px)", left: isMobile ? "0": isLanding ? "0" : "64px" }}>
      <Box sx={{ display: "flex", gap: "0.5rem" }}>
        <img src="/assets/icons/mobile_app_icon.svg" style={{ maxWidth: "36px", height: "inherit", maxHeight: "49px" }} alt={"logo"}/>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography sx={{ fontSize: "0.75rem", color: "#FFFFFF" }}>GoodVets</Typography>
          <Typography sx={{ fontSize: "0.625rem", color: "#AAAAAA", marginTop: "-0.3rem", padding: 0 }}>Download Our App</Typography>
        </Box>
      </Box>
      <OpenAppButton onClick={openStore}>
          OPEN APP
      </OpenAppButton>
    </HeaderBox>
  );
};

export default AppHeaderMobile;
